/**
 * Which app store applies to the visitor's device. Desktop and unknown
 * devices get both stores; a phone gets its own. Safe when there is no
 * browser (pre-render, tests).
 */
export type StorePlatform = "ios" | "android" | "other";

export function storePlatform(): StorePlatform {
  if (typeof navigator === "undefined") return "other";
  const ua = navigator.userAgent || "";
  const iPadOS = navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1;
  if (/iPhone|iPad|iPod/i.test(ua) || iPadOS) return "ios";
  if (/Android/i.test(ua)) return "android";
  return "other";
}

export function storeAvailabilityLine(): string {
  switch (storePlatform()) {
    case "ios":
      return "Free on the App Store.";
    case "android":
      return "Free on Google Play.";
    default:
      return "Free on the App Store and Google Play.";
  }
}
